import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./editBook.scss";
import Navbar from "../../components/navbar/Navbar";
import { CloudUpload, Edit, Save, Cancel } from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Chip,
  styled,
  Paper,
  Typography,
  Backdrop,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Box,
  Container,
  Stack,
  InputLabel,
  Select,
} from "@mui/material";
import {
  deleteDoc,
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db, realtimeDB, storage } from "../../firebase";
import { generateKeywords } from "../../functions";
import {
  getDownloadURL,
  ref as StorageRef,
  uploadBytes,
} from "firebase/storage";
import { useUserData } from "../../context/UserContext";
import { child, get, ref as realtimeRef } from "firebase/database";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function EditBook() {
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const bookData = state && state.bookData;
  const { userData } = useUserData();
  let dataValue;
  switch (state.type) {
    case "main":
      dataValue = {
        buttonMessage: "Update",
      };
      break;
    case "pending":
      dataValue = {
        buttonMessage: "Approve",
      };
      break;
    default:
      break;
  }

  const [controlAccess, setControlAccess] = useState("limited");
  const [radioTypeValue, setRadioTypeValue] = useState("book");
  const [radioPaymentValue, setRadioPaymentValue] = useState("paid");
  const [categories, setCategories] = useState({});
  const [categoryArray, setCategoryArray] = useState([]);
  const [subCategoryArray, setSubCategoryArray] = useState([]);
  const [categoryValue, setCategoryValue] = useState("");
  const [subCategoryValue, setSubCategoryValue] = useState("");
  const [tagData, setTagData] = useState([]);
  const [tagServerData, setTagServerData] = useState([]);
  const [image, setImage] = useState(null);
  const [samplePdf, setSamplePdf] = useState(null);
  const [mainPdf, setMainPdf] = useState(null);
  const [formData, setFormData] = useState(bookData);
  const [formErrors, setFormErrors] = useState({
    name: "",
    about: "",
    author: "",
    discount: "",
    price: "",
    isbn: "",
    language: "",
    pdf_password: "",
    pages: "",
    category: "",
    subCategory: "",
    tags: "",
  });
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const [progress, setProgress] = useState(10);

  useEffect(() => {
    if (bookData.tags) {
      setTagData(bookData.tags);
    }
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + 10
      );
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);
  useEffect(() => {
    setControlAccess(userData.controlAccess);
  }, [userData]);
  const validateForm = () => {
    const errors = {
      name: "",
      about: "",
      author: "",
      discount: "",
      price: "",
      isbn: "",
      language: "",
      pdf_password: "",
      pages: "",
      category: "",
      subCategory: "",
      tags: "",
    };

    let isValid = true;

    if (!formData.name.trim()) {
      errors.name = "Book Name cannot be empty";
      isValid = false;
    }
    if (!formData.about.trim()) {
      errors.about = "About cannot be empty";
      isValid = false;
    }
    if (!formData.author.trim()) {
      errors.author = "Author Name cannot be empty";
      isValid = false;
    }

    if (!formData.discount) {
      errors.discount = "Discount cannot be empty";
      isValid = false;
    }
    if (!formData.price) {
      errors.price = "Price cannot be empty";
      isValid = false;
    }
    if (!formData.isbn.trim()) {
      errors.isbn = "ISBN No. cannot be empty";
      isValid = false;
    }
    if (!formData.language.trim()) {
      errors.language = "Language cannot be empty";
      isValid = false;
    }
    if (!formData.pdf_password.trim()) {
      errors.pdf_password = "PDF Password cannot be empty";
      isValid = false;
    }
    if (!formData.pages) {
      errors.pages = "PDF Pages cannot be empty";
      isValid = false;
    }
    // Additional validation for category, subcategory and tags
    if (!categoryValue.trim()) {
      errors.category = "Category selection is required";
      isValid = false;
    }
    
    if (!subCategoryValue.trim()) {
      errors.subCategory = "Sub Category selection is required";
      isValid = false;
    }
    
    if (tagData.length === 0) {
      errors.tags = "Please add at least one tag for better categorization";
      isValid = false;
    }

    if (!isValid) {
      // Show specific field errors instead of a general alert
      const errorMessage = "Please fix the validation errors before submitting.";
      alert(errorMessage);
    }
    setFormErrors(errors);

    return isValid;
  };
  const handleSubmit = async (e) => {
    const nameSearchArray = generateKeywords(formData.name);
    const authorSearchArray = generateKeywords(formData.author);
    const publisherSearchArray = generateKeywords(formData.publisher);
    const categorySearchArray = generateKeywords(categoryValue);
    const subCategorySearchArray = generateKeywords(subCategoryValue);

    var tagsSearchArray = [];
    tagData.forEach(
      (tag) =>
        (tagsSearchArray = [...tagsSearchArray, ...generateKeywords(tag)])
    );
    // Validate the form before submitting
    if (validateForm()) {
      // Perform the form submission logic here
      var mapData = formData;
      mapData.price = parseInt(mapData.price, 10) || 0;
      mapData.discount = parseInt(mapData.discount, 10) || 0;
      mapData.pages = parseInt(mapData.pages, 10) || 0;
      mapData.unitSold = parseInt(mapData.unitSold, 10) || 0;
      mapData.rating = parseFloat(mapData.rating) || 0.0;
      mapData.searchKeywords = [
        ...nameSearchArray,
        ...authorSearchArray,
        ...publisherSearchArray,
        ...categorySearchArray,
        ...subCategorySearchArray,
        ...tagsSearchArray,
      ];
      // delete mapData["id"];
      delete mapData["publish_on"];
      mapData.tags = tagData;
      mapData.payment_type =
        radioPaymentValue.charAt(0).toUpperCase() + radioPaymentValue.slice(1);
      mapData.eType =
        radioTypeValue.charAt(0).toUpperCase() + radioTypeValue.slice(1);
      mapData.category = categoryValue;
      mapData.subCategory = subCategoryValue;
      setOpen(true);
      uploadDataToFirestore(mapData);
    } else {
      console.log("Form is not valid, do not submit");
    }
  };
  const uploadDataToFirestore = async (mapData) => {
    try {
      // Upload cover image
      if (image) {
        const coverImgRef = StorageRef(
          storage,
          `files/${bookData.id}/cover_image.jpg`
        );
        const coverSnapshot = await uploadBytes(coverImgRef, image);
        const coverUrl = await getDownloadURL(coverSnapshot.ref);
        mapData.coverImage = coverUrl;
        mapData.thumbImage = coverUrl;
      }

      // Upload main PDF
      if (mainPdf) {
        const mainPDFRef = StorageRef(
          storage,
          `files/${bookData.id}/${bookData.id}.pdf`
        );
        const mainSnapshot = await uploadBytes(mainPDFRef, mainPdf);
        mapData.pdfUrl = await getDownloadURL(mainSnapshot.ref);
      }

      // Upload sample PDF
      if (samplePdf) {
        const samplePDFRef = StorageRef(
          storage,
          `files/${bookData.id}/sample_${bookData.id}.pdf`
        );
        const sampleSnapshot = await uploadBytes(samplePDFRef, samplePdf);
        mapData.samplePdfUrl = await getDownloadURL(sampleSnapshot.ref);
      }

      // Update Firestore document

      const bookref = doc(db, "eLibrary", bookData.id);
      if (state.type === "main") {
        await updateDoc(bookref, mapData);
      } else {
        const bookrefTobeDeleted = doc(db, "pendingBooks", bookData.id);
        await deleteDoc(bookrefTobeDeleted);
        await setDoc(bookref, {
          ...mapData,
          publish_on: serverTimestamp(),
        });
      }

      setOpen(false);
      alert("Done");
      navigate(-1);
    } catch (error) {
      setOpen(false);
      alert("Error uploading document: " + error.message);
    }
  };

  const addTag = (newTag) => {
    if (!tagData.includes(newTag)) {
      setTagData((prevTags) => [...prevTags, newTag]);
    }
  };

  const handleSamplePDFChange = (e) => {
    const selectedPdf = e.target.files[0];

    if (selectedPdf && selectedPdf.type === "application/pdf") {
      setSamplePdf(selectedPdf);
    } else {
      alert("Please select a valid PDF file.");
    }
  };
  const handleMainPDFChange = (e) => {
    const selectedPdf = e.target.files[0];

    if (selectedPdf && selectedPdf.type === "application/pdf") {
      setMainPdf(selectedPdf);
    } else {
      alert("Please select a valid PDF file.");
    }
  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    // Check if the selected file is an image
    if (selectedImage && selectedImage.type.startsWith("image/")) {
      setImage(selectedImage);
    } else {
      alert("Please select a valid image file.");
    }
  };

  const handleDeleteTag = (tagToRemove) => () => {
    setTagData((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
  };
  const handleInputNumber = (event) => {
    event.target.value = event.target.value.replace(/[^0-9]/g, "");
  };

  const handleRadioType = (event) => {
    setRadioTypeValue(event.target.value);
  };
  const handleRadioPaymentMode = (event) => {
    setRadioPaymentValue(event.target.value);
  };
  useEffect(() => {
    setRadioTypeValue(bookData.eType.toLowerCase());
    setRadioPaymentValue(bookData.payment_type.toLowerCase());
    
    // Initialize category value from bookData
    if (bookData.category) {
      setCategoryValue(bookData.category);
    }
    
    // Initialize subcategory value from bookData
    if (bookData.subCategory) {
      setSubCategoryValue(bookData.subCategory);
    }

    // Fetch data from realtime database
    const fetchData = async () => {
      try {
        const catRef = realtimeRef(realtimeDB);
        const snapshot = await get(child(catRef, "categories"));
        
        if (snapshot.exists()) {
          const data = snapshot.val();
          setCategories(data);
          
          // After categories are loaded, find the category key that matches bookData.category
          if (bookData.category) {
            const categoryKey = Object.keys(data).find(
              key => data[key].title === bookData.category
            );
            
            if (categoryKey) {
              // Set subcategory array based on the found category
              setSubCategoryArray(data[categoryKey].subCategories || []);
            }
          }
        } else {
          console.log("No category available");
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
      
      // Fetch tags
      try {
        const documentRef = doc(db, "Alphabet", "home");
        const snapshot = await getDoc(documentRef);
        const tags = snapshot.data().tags;
        setTagServerData(tags);
      } catch (error) {
        console.error("Error fetching tags from Firestore:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    setCategoryArray(categories);
  }, [categories]);

  return (
    <div className="editBook">
      <div className="editBookContainer">
      <Navbar />
        <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
          {/* Header */}
          <Card elevation={2} sx={{ mb: 3 }}>
            <CardHeader
              title={
                <Box display="flex" alignItems="center" gap={1}>
                  <Edit color="primary" />
                  <Typography variant="h5" component="h1">
                    Edit Book Details
                  </Typography>
                </Box>
              }
              subheader={`Editing: ${bookData.name}`}
            />
          </Card>

          <Grid container spacing={3}>
            {/* Left Panel - Media Upload */}
            <Grid item xs={12} md={4} sx={{ order: { xs: 1, md: 1 } }}>
              <Card
                elevation={2}
                sx={{ 
                  height: "fit-content", 
                  position: { xs: "static", md: "sticky" }, 
                  top: 20 
                }}
              >
                <CardHeader title="Media Files" />
                <CardContent>
                  <Stack spacing={3} alignItems="center">
                    {/* Book Cover */}
                    <Box>
                      <Typography variant="subtitle2" gutterBottom>
                        Book Cover
                      </Typography>
                      <Box
                        sx={{
                          width: 200,
                          height: 280,
                          border: "2px dashed #e0e0e0",
                          borderRadius: 2,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          mb: 2,
                          position: "relative",
                          "&:hover": {
                            borderColor: "primary.main",
                            backgroundColor: "action.hover",
                          },
                        }}
                      >
                        <img
                          src={
                            image
                              ? URL.createObjectURL(image)
                              : bookData.thumbImage
                          }
                          alt="Book cover"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 8,
                          }}
                        />
                      </Box>
                      <Button
                        component="label"
                        variant="outlined"
                        startIcon={<CloudUpload />}
                        fullWidth
                        size="small"
                      >
                        Change Cover
                        <VisuallyHiddenInput
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                      </Button>
                    </Box>

                    <Divider sx={{ width: "100%" }} />

                    {/* Sample PDF */}
                    <Box sx={{ width: "100%" }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Sample PDF
                      </Typography>
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 2,
                          mb: 1,
                          backgroundColor: samplePdf
                            ? "success.light"
                            : "grey.50",
                          color: samplePdf
                            ? "success.contrastText"
                            : "text.secondary",
                        }}
                      >
                        <Typography variant="body2" noWrap>
                          {samplePdf
                            ? `✓ ${samplePdf.name}`
                            : "No sample PDF selected"}
                        </Typography>
                      </Paper>
                      <Button
                        component="label"
                        variant="outlined"
                        startIcon={<CloudUpload />}
                        fullWidth
                        size="small"
                      >
                        Upload Sample
                        <VisuallyHiddenInput
                          type="file"
                          accept=".pdf"
                          onChange={handleSamplePDFChange}
                        />
                      </Button>
                    </Box>

                    {/* Main PDF */}
                    <Box sx={{ width: "100%" }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Main PDF
                      </Typography>
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 2,
                          mb: 1,
                          backgroundColor: mainPdf
                            ? "success.light"
                            : "grey.50",
                          color: mainPdf
                            ? "success.contrastText"
                            : "text.secondary",
                        }}
                      >
                        <Typography variant="body2" noWrap>
                          {mainPdf
                            ? `✓ ${mainPdf.name}`
                            : "No main PDF selected"}
                        </Typography>
                      </Paper>
                      <Button
                        component="label"
                        variant="outlined"
                        startIcon={<CloudUpload />}
                        fullWidth
                        size="small"
                      >
                        Upload Main PDF
                        <VisuallyHiddenInput
                          type="file"
                          accept=".pdf"
                          onChange={handleMainPDFChange}
                        />
                      </Button>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
            {/* Right Panel - Form */}
            <Grid item xs={12} md={8} sx={{ order: { xs: 2, md: 2 } }}>
              <Stack spacing={3}>
                {/* Basic Information */}
                <Card elevation={2}>
                  <CardHeader title="Basic Information" />
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Book Name"
                          defaultValue={bookData.name}
                          onChange={(e) => {
                            setFormData({ ...formData, name: e.target.value });
                          }}
                          error={formErrors.name !== ""}
                          helperText={formErrors.name}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="About"
                          multiline
                          rows={4}
                          defaultValue={bookData.about}
                          onChange={(e) => {
                            setFormData({ ...formData, about: e.target.value });
                          }}
                          error={formErrors.about !== ""}
                          helperText={formErrors.about}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Author Name"
                          defaultValue={bookData.author}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              author: e.target.value,
                            });
                          }}
                          error={formErrors.author !== ""}
                          helperText={formErrors.author}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Publisher"
                          value={userData.fullName}
                          disabled
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Language"
                          defaultValue={bookData.language}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              language: e.target.value,
                            });
                          }}
                          error={formErrors.language !== ""}
                          helperText={formErrors.language}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="ISBN No."
                          defaultValue={bookData.isbn}
                          onChange={(e) => {
                            setFormData({ ...formData, isbn: e.target.value });
                          }}
                          error={formErrors.isbn !== ""}
                          helperText={formErrors.isbn}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                {/* Pricing & Details */}
                <Card elevation={2}>
                  <CardHeader title="Pricing & Details" />
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Price"
                          onInput={handleInputNumber}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                ₹
                              </InputAdornment>
                            ),
                          }}
                          onChange={(e) => {
                            setFormData({ ...formData, price: parseInt(e.target.value, 10) || 0 });
                          }}
                          defaultValue={bookData.price}
                          error={formErrors.price !== ""}
                          helperText={formErrors.price}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Discount"
                          onInput={handleInputNumber}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">%</InputAdornment>
                            ),
                          }}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              discount: parseInt(e.target.value, 10) || 0,
                            });
                          }}
                          defaultValue={bookData.discount}
                          error={formErrors.discount !== ""}
                          helperText={formErrors.discount}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="PDF Password"
                          defaultValue={bookData.pdf_password}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              pdf_password: e.target.value,
                            });
                          }}
                          error={formErrors.pdf_password !== ""}
                          helperText={formErrors.pdf_password}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="PDF Pages"
                          onInput={handleInputNumber}
                          defaultValue={bookData.pages}
                          onChange={(e) => {
                            setFormData({ ...formData, pages: parseInt(e.target.value, 10) || 0 });
                          }}
                          error={formErrors.pages !== ""}
                          helperText={formErrors.pages}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                {/* Categories & Tags */}
                <Card elevation={2}>
                  <CardHeader title="Categories & Tags" />
                  <CardContent>
                    <Box mb={2}>
                      {categoryValue ? (
                        <Typography variant="subtitle2" color="primary">
                          Selected Category: {categoryValue}
                          {subCategoryValue && ` > ${subCategoryValue}`}
                        </Typography>
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          Please select a category and subcategory for your book
                        </Typography>
                      )}
                    </Box>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          select
                          label="Category"
                          value={Object.keys(categoryArray).find(
                            key => categoryArray[key]?.title === categoryValue
                          ) || ""}
                          onChange={(e) => {
                            const selectedKey = e.target.value;
                            setCategoryValue(categoryArray[selectedKey].title);
                            setSubCategoryArray(categories[selectedKey].subCategories);
                            // Reset subcategory when category changes
                            setSubCategoryValue("");
                          }}
                          variant="outlined"
                          error={formErrors.category !== ""}
                          helperText={formErrors.category}
                        >
                          {Object.keys(categoryArray).map((category) => (
                            <MenuItem key={category} value={category}>
                              {categoryArray[category].title}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          select
                          label="Sub Category"
                          value={subCategoryValue}
                          onChange={(e) => {
                            setSubCategoryValue(e.target.value);
                          }}
                          variant="outlined"
                          disabled={subCategoryArray.length === 0}
                          error={formErrors.subCategory !== ""}
                          helperText={
                            subCategoryArray.length === 0
                              ? "Select a category first"
                              : formErrors.subCategory || ""
                          }
                        >
                          {subCategoryArray.map((subCategory) => (
                            <MenuItem key={subCategory} value={subCategory}>
                              {subCategory}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="tags-select-label">Add Tags</InputLabel>
                          <Select
                            labelId="tags-select-label"
                            id="tags-select"
                            value={""}
                            label="Add Tags"
                            onChange={(e) => {
                              const newTag = e.target.value;
                              if (newTag) {
                                addTag(newTag.toLowerCase());
                              }
                            }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 300
                                }
                              }
                            }}
                          >
                            <MenuItem value="" disabled>
                              <em>Select a tag to add</em>
                            </MenuItem>
                            {tagServerData
                              .filter(tag => !tagData.includes(tag.toLowerCase()))
                              .map((value) => (
                                <MenuItem key={value} value={value}>
                                  {value}
                                </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                          <Typography variant="subtitle2" gutterBottom>
                            {tagData.length > 0 ? `Current Tags: (${tagData.length})` : "No tags added yet"}
                          </Typography>
                          {formErrors.tags && (
                            <Typography variant="caption" color="error">
                              {formErrors.tags}
                            </Typography>
                          )}
                        </Box>
                        <Paper
                          variant="outlined"
                          sx={{
                            p: 1,
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1,
                            minHeight: 50,
                            alignItems: "flex-start",
                            alignContent: "flex-start",
                            backgroundColor: tagData.length > 0 ? "rgba(25, 118, 210, 0.04)" : "transparent",
                          }}
                        >
                          {tagData.length === 0 && (
                            <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
                              Select tags from the dropdown above to improve book categorization
                            </Typography>
                          )}
                            {tagData.map((data) => (
                              <Chip
                                key={data}
                                label={data}
                                variant="outlined"
                                color="primary"
                                onDelete={handleDeleteTag(data)}
                                sx={{
                                  borderRadius: "16px",
                                  fontWeight: 500,
                                  '&:hover': {
                                    backgroundColor: 'rgba(25, 118, 210, 0.12)',
                                  }
                                }}
                               
                                
                                size="small"
                              />
                            ))}
                          </Paper>
                        </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                {/* Settings */}
                <Card elevation={2}>
                  <CardHeader title="Settings" />
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Content Type</FormLabel>
                          <RadioGroup
                            row
                            value={radioTypeValue}
                            onChange={handleRadioType}
                            sx={{ mt: 1 }}
                          >
                            <FormControlLabel
                              value="book"
                              control={<Radio />}
                              label="Book"
                            />
                            <FormControlLabel
                              value="notes"
                              control={<Radio />}
                              label="Notes"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Payment Mode</FormLabel>
                          <RadioGroup
                            row
                            value={radioPaymentValue}
                            onChange={handleRadioPaymentMode}
                            sx={{ mt: 1 }}
                          >
                            <FormControlLabel
                              value="paid"
                              control={<Radio />}
                              label="Paid"
                            />
                            <FormControlLabel
                              value="free"
                              control={<Radio />}
                              label="Free"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                {/* Action Buttons */}
                {controlAccess === "full" && (
                  <Card elevation={2}>
                    <CardContent>
                      <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="flex-end"
                      >
                        <Button
                          variant="outlined"
                          startIcon={<Cancel />}
                          onClick={() => navigate(-1)}
                          size="large"
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          startIcon={<Save />}
                          onClick={handleSubmit}
                          size="large"
                          sx={{ minWidth: 120 }}
                        >
                          {dataValue.buttonMessage}
                        </Button>
                      </Stack>
                    </CardContent>
                  </Card>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Container>

        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Card sx={{ p: 3, textAlign: "center", minWidth: 300 }}>
            <CircularProgress size={60} sx={{ mb: 2 }} />
            <Typography variant="h6" gutterBottom>
              Updating Book...
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Please wait while we save your changes
            </Typography>
          </Card>
        </Backdrop>
      </div>
    </div>
  );
}

export default EditBook;
